import { useState } from "react";
import { Headphones } from "lucide-react";
import CallbackRequestModal from "./CallbackRequestModal";
import { trackCTA } from "../lib/analytics";

/**
 * V10 P1 — Floating "Get Free Consultation" CTA.
 * Sits on the LEFT side of the viewport (WhatsApp is on the right).
 * Opens CallbackRequestModal in "consultation" variant.
 *
 * Hidden on the smallest screens to avoid colliding with MobileCTABar — instead,
 * MobileCTABar already has its own demo button. This CTA is for tablet+ users.
 */
export default function FreeConsultationCTA() {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button
                type="button"
                onClick={() => {
                    trackCTA("free_consultation_clicked", { cta_location: "floating-left" });
                    setOpen(true);
                }}
                data-testid="floating-consultation-cta"
                aria-label="Get a free consultation"
                className="fixed left-[max(1rem,env(safe-area-inset-left,0px))] bottom-[calc(80px+env(safe-area-inset-bottom,0px))] xl:bottom-6 z-[55] hidden md:inline-flex items-center gap-2 bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] text-white px-4 py-3 rounded-full shadow-2xl hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all border-2 border-amber-400/60"
            >
                <Headphones className="w-5 h-5 text-amber-300" />
                <span className="font-semibold text-sm">Free Consultation</span>
            </button>
            <CallbackRequestModal
                open={open}
                onClose={() => setOpen(false)}
                variant="consultation"
            />
        </>
    );
}
